import { createContext, useEffect, useReducer } from "react";

import axios from "../utils/axios";
import CafFormReducer from "../reducers/CafFormReducer";
import { isValidToken, setSession } from "../utils/jwt";
import { CafFormConstants } from "../constants/cafform.constants";
import { saveFile } from "../utils/common";
const initialState = {
  isLoading: true,
  cafForms: [],
  paging: {
    totalNumberOfRecords: 0,
    totalNumberOfPages: 0,
    pageNumber: 0,
    pageSize: 0,
  },
  hasError: false,
  errorMessage: "",
  cafFormSearchResults: [],
  cafForm: {},
  isUpload: false,
  uploadError: false,
  uploadSuccess: false,
  isSubmitting: false,
  isLoadingDownload: false,
  cafFormAutoSearchResults: {
    data: [],
    paging: {
      hasNextPage: false,
      hasPreviousPage: false,
      pageNumber: 0,
      pageSize: 0,
      totalNumberOfPages: 0,
      totalNumberOfRecords: 0,
    },
  },
  autoSearchLoading: false,
  isLoading: true,
  downloadFileType: "",
  isLoadingAutoSearch: true,
  approveSuccess: false,
  approveError: false,
  isApprove: false,
  rejectSuccess: false,
  rejectError: false,
  isReject: false,
};
const initPayload = {
  filters: [],
  pagination: {
    pageNumber: 1,
    pageSize: 100,
  },
  sortFields: [],
};

const CafFormContext = createContext({
  ...initialState,
  getAllCafForm: () => {},
  getKycDocumentPreview: () => {},
  addCafForm: () => {},
  searchCafForm: () => {},
  autoSearchCafForm: () => {},
  getCafForm: () => {},
  resetCafForm: () => {},
  updateCafForm: () => {},
  downloadFile: () => {},
  sampleFile: () => {},
  uploadFile: () => {},
  approveCafForm: () => {},
  rejectCafForm: () => {},
});

function CafFormProvider({ children }) {
  const [state, dispatch] = useReducer(CafFormReducer, initialState);

  const getAllCafForm = async (payload) => {
    try {
      dispatch({
        type: CafFormConstants.FETCH_CAF_FORM_REQUEST,
      });
      const response = await axios.post("/caf/list", payload);
      dispatch({
        type: CafFormConstants.FETCH_CAF_FORM_SUCCESS,
        payload: response.data,
      });
      return response.data;
    } catch (exception) {
      dispatch({
        type: CafFormConstants.FETCH_CAF_FORM_FAILURE,
      });
    }
  };
  const searchCafForm = async (payload) => {
    try {
      const response = await axios.post("/caf/search", payload);
      dispatch({
        type: CafFormConstants.CAF_FORM_SEARCH_REQUEST,
      });
      console.log(response.data, "response.data");
      dispatch({
        type: CafFormConstants.CAF_FORM_SEARCH_SUCCESS,
        payload: response.data,
      });
    } catch (exception) {
      dispatch({
        type: CafFormConstants.CAF_FORM_SEARCH_FAILURE,
      });
    }
  };
  const autoSearchCafForm = async (payload) => {
    try {
      const response = await axios.post("/caf/auto-search", payload);
      dispatch({
        type: CafFormConstants.CAF_FORM_AUTO_SEARCH_REQUEST,
      });
      console.log(response.data, "response.data");
      dispatch({
        type: CafFormConstants.CAF_FORM_AUTO_SEARCH_SUCCESS,
        payload: response.data,
      });
    } catch (exception) {
      dispatch({
        type: CafFormConstants.CAF_FORM_AUTO_SEARCH_FAILURE,
      });
    }
  };
  const addCafForm = async (payload) => {
    const response = await axios.post("/caf/add", payload, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    dispatch({
      type: CafFormConstants.ADD_CAF_FORM_REQUEST,
    });
    dispatch({
      type: CafFormConstants.ADD_CAF_FORM_SUCCESS,
      payload: response.data,
    });
  };

  const getCafForm = async (id) => {
    const response = await axios.get("/caf/" + id);
    dispatch({
      type: CafFormConstants.GET_CAF_FORM_REQUEST,
    });
    dispatch({
      type: CafFormConstants.GET_CAF_FORM_SUCCESS,
      payload: response.data,
    });
  };

  const updateCafForm = async (id, formData) => {
    const response = await axios.put(`/caf/update/${id}`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    dispatch({ type: CafFormConstants.UPDATE_CAF_FORM_REQUEST });
    dispatch({ type: CafFormConstants.UPDATE_CAF_FORM_SUCCESS, payload: response.data });
  };

  const downloadFile = async (fileType, payload) => {
    dispatch({
      type: CafFormConstants.DOWNLOAD_CAF_FORM_REQUEST,
      payload: {
        fileType: fileType,
      },
    });
    const response = await axios.post("/caf/export/" + fileType, payload, {
      responseType: "blob",
    });
    console.log(response.headers, "filename");
    //const filename = response.headers.get("content-disposition").split('"');

    await saveFile(response.data, "cafForm." + fileType);
    dispatch({
      type: CafFormConstants.DOWNLOAD_CAF_FORM_SUCCESS,
      payload: response.data,
    });
  };

  const sampleFile = async (fileType) => {
    const response = await axios.get("/caf/sample/" + fileType, {
      responseType: "blob",
    });

    await saveFile(response.data, "sample_cafForm." + fileType);
    dispatch({
      type: CafFormConstants.DOWNLOAD_CAF_FORM_REQUEST,
    });
    dispatch({
      type: CafFormConstants.DOWNLOAD_CAF_FORM_SUCCESS,
      payload: response.data,
    });
  };

  const uploadFile = async (payload) => {
    try {
      dispatch({
        type: CafFormConstants.UPLOAD_CAF_FORM_REQUEST,
      });
      const response = await axios({
        url: "/caf/upload",
        method: "POST",
        data: payload,
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      dispatch({
        type: CafFormConstants.UPLOAD_CAF_FORM_SUCCESS,
        payload: response.data,
      });
    } catch (error) {
      console.log("errr", error);
      dispatch({
        type: CafFormConstants.UPLOAD_CAF_FORM_FAILURE,
      });
    }
  };

  const getKycDocumentPreview = async (cafId, filePath) => {
    dispatch({
      type: CafFormConstants.PREVIEW_KYC_REQUEST,
    });
    const response = await axios.get("/caf/preview/" + cafId + "/" + filePath, {
      responseType: "blob",
    });
    dispatch({
      type: CafFormConstants.PREVIEW_KYC_SUCCESS,
    });
    return URL.createObjectURL(response.data);
  };
  const approveCafForm = async (payload) => {
    const response = await axios.post("/caf/approve-caf", payload);

    dispatch({
      type: CafFormConstants.APPROVE_CAF_FORM_REQUEST,
    });
    dispatch({
      type: CafFormConstants.APPROVE_CAF_FORM_SUCCESS,
      payload: response.data,
    });
  };
  const rejectCafForm = async (payload) => {
    const response = await axios.post("/caf/reject-caf", payload);

    dispatch({
      type: CafFormConstants.REJECT_CAF_FORM_REQUEST,
    });
    dispatch({
      type: CafFormConstants.REJECT_CAF_FORM_SUCCESS,
      payload: response.data,
    });
  };

  const resetCAFForm = async () => {
    dispatch({
      type: CafFormConstants.GET_CAF_FORM_REQUEST,
    });
    dispatch({
      type: CafFormConstants.GET_CAF_FORM_SUCCESS,
      payload: {},
    });
  };

  return (
    <CafFormContext.Provider
      value={{
        ...state,
        getAllCafForm,
        addCafForm,
        searchCafForm,
        autoSearchCafForm,
        getCafForm,
        updateCafForm,
        downloadFile,
        sampleFile,
        uploadFile,
        getKycDocumentPreview,
        approveCafForm,
        rejectCafForm,
        resetCAFForm,
      }}
    >
      {children}
    </CafFormContext.Provider>
  );
}

export { CafFormContext, CafFormProvider };
